
import { Vue, Component, Prop } from "vue-property-decorator";
import { Message } from "@/generated/graphql";
import moment from "moment";

@Component
export default class MessageSeparatorByDate extends Vue {
  @Prop({ type: Object, required: true }) readonly message!: Message;


 get separator(): string {
  const createdAt = moment(this.message.created_at);

    return createdAt.format("dddd, MMM DD");
}
}
